import styled from "styled-components";
import { colors } from "../../constants/colors";

export const H1 = styled.h1`
  color: ${(props) => props.color};
  margin-top: 0;
`;

export const H5 = styled.h5`
  color: ${(props) => props.color};
  text-align: center;
  font-weight: 200;
  margin: 0;
  font-family: "Open Sans";
`;

export const H3 = styled.h5`
  color: ${(props) => props.color};
  text-align: center;
  font-weight: 600;
  margin: 15px;
  font-family: "Open Sans";
`;

export const A = styled.a`
  color: ${colors.PRIMARY};
  font-weight: 600;
`;
